import { Spin } from 'antd';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGetCurrentUser } from '@/hooks/app';
import { hasPermission } from '@/utils/permission';
import { ROUTESPATH } from '@/routes/constant';

/**
 * Ordered list of nav routes matching the side menu top-to-bottom.
 * The first route the user has permission for is where they land.
 */
const ORDERED_ROUTES: { permission: string; path: string }[] = [
  { permission: 'view_dashboard', path: ROUTESPATH.DASHBOARD },
  { permission: 'view_quotes', path: ROUTESPATH.QUOTES },
  { permission: 'view_orders', path: ROUTESPATH.ORDERS },
  { permission: 'view_customers', path: ROUTESPATH.CUSTOMERS },
  { permission: 'view_onboarding', path: ROUTESPATH.ONBOARDING },
  { permission: 'view_credit_control', path: ROUTESPATH.CREDIT_CONTROL },
  { permission: 'view_currency_exchange', path: ROUTESPATH.CURRENCY_EXCHANGE },
  { permission: 'view_product_configurator', path: ROUTESPATH.PRODUCT_CONFIGURATOR },
  { permission: 'view_analytics', path: ROUTESPATH.ANALYTICS },
  { permission: 'view_users', path: ROUTESPATH.USERMANAGEMENT },
  { permission: 'view_depots', path: ROUTESPATH.DEPOTS },
  { permission: 'view_settings', path: ROUTESPATH.SETTINGS },
  { permission: 'view_permissions', path: ROUTESPATH.PERMISSIONS },
];

export const SmartRedirect: React.FC = () => {
  const { data: currentUser, isLoading } = useGetCurrentUser();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" />
      </div>
    );
  }

  const permissions = currentUser?.permission;
  const firstAllowed = ORDERED_ROUTES.find((r) => hasPermission(permissions, r.permission));

  return <Navigate to={firstAllowed?.path ?? ROUTESPATH.UNAUTHORIZED} replace />;
};
